import { render, staticRenderFns } from "./epms3020_waste.vue?vue&type=template&id=640eff4a&scoped=true"
import script from "./epms3020_waste.vue?vue&type=script&lang=js"
export * from "./epms3020_waste.vue?vue&type=script&lang=js"
import style0 from "./epms3020_waste.vue?vue&type=style&index=0&id=640eff4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640eff4a",
  null
  
)

export default component.exports